import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import SessionPage from "@/pages/SessionPage";
import ExchangePage from "@/pages/ExchangePage";
import PostDetailPage from "@/pages/PostDetailPage";
import CuratorPage from "@/pages/CuratorPage";
import MentorsPage from "@/pages/MentorsPage";
import StackPage from "@/pages/StackPage";
import InterestPage from "@/pages/InterestPage";

const Layout = () => (
  <div className="min-h-screen bg-cream flex flex-col font-sans">
    <Header />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <Toaster
      position="bottom-center"
      toastOptions={{
        style: {
          background: '#14524F',
          color: '#fff',
          border: 'none',
          borderRadius: '9999px',
          fontWeight: 600,
        },
      }}
    />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/session/:id" element={<SessionPage />} />
          <Route path="/exchange" element={<ExchangePage />} />
          <Route path="/exchange/new" element={<ExchangePage openSubmit />} />
          <Route path="/exchange/post/:id" element={<PostDetailPage />} />
          <Route path="/curator" element={<CuratorPage />} />
          <Route path="/mentors" element={<MentorsPage />} />
          <Route path="/stack" element={<StackPage />} />
          <Route path="/interest" element={<InterestPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
